import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import LoadingWheel from "../../components/shared/LoadingWheel";
import { usePageNameContext } from "../../contexts/PageTitleContext";

import PartVehicleDetails from "../../components/leads/LeadParts/PartVehicleDetails";
import useVehicleSingle from "../../data/useVehicleSingle";
import VehiclePartsCard from "../../components/vehicles/VehiclePartsCard";
import VehicleNotes from "../../components/leads/LeadInformation/VehicleNotes";
import AwaitingInventoryStatusDropdown from "../../components/awaitingInventory/AwaitingInventoryStatusDropdown";
import VehicleLocationDropdown from "../../components/vehicles/VehicleLocationDropdown";
import YardStatusDropdown from "../../components/awaitingInventory/YardStatusDropdown";
import PartsPriorityDropdown from "../../components/awaitingInventory/PartsPriorityDropdown";
import VehicleJobs from "../../components/vehicles/VehicleJobs";
import CreateJobs from "../../components/jobs/CreateJobs";
import LeadNotes from "../../components/leads/LeadInformation/LeadNotes";
import Tabs from "../../components/shared/Tabs/Tabs";
import LeadDocuments from "../../components/leads/LeadDocuments";
import useLeadByVehicleId from "../../data/useLeadByVehicleId";
import PartVehicleImages from "../../components/leads/LeadParts/LeadImagesCarousel";

export default function Vehicle() {
  const { setInfo } = usePageNameContext();
  const { vehicleId } = useParams();
  const { vehicle, lead } = useVehicleSingle(vehicleId);

  const [viewType, setViewType] = useState(0);
  const viewTypes = [
    { value: 0, label: "Vehicle Information" },
    { value: 1, label: `Documents` },
  ];


  useEffect(() => {
    if (!vehicle.data?.data && !vehicle.isLoading) {
      setInfo({
        name: "Vehicle not found",
        desc: "The vehicle you are looking for does not exist",
      });
      return;
    }

    if (!vehicle.data?.data && vehicle.isLoading) {
      setInfo({
        name: "",
        desc: "",
      });
      return;
    }

    setInfo({
      name: `${vehicle.data?.data?.vrm} ${vehicle.data?.data?.combinedMake} ${vehicle.data?.data?.modelRangeDescription}`,
      desc: `View and manage ${vehicle.data?.data?.vrm}`,
    });
  }, [vehicleId, vehicle.isLoading]);


  if (vehicle.isLoading || !vehicle.data?.data) {
    return (
      <div className="mt-8 min-h-[50vh] my-4 p-4 bg-white rounded-lg shadow">
        <LoadingWheel />
      </div>
    );
  }



  return (
    <>
      <Tabs viewType={viewType} viewTypes={viewTypes} setViewType={setViewType} />

      {
        {
          0: (
            <div className="mt-8 flex flex-col gap-4">
              <div className="flex text-sm text-gray-700 gap-x-4">
                <div className="flex flex-col">
                  <p>Parts Status</p>
                  <AwaitingInventoryStatusDropdown
                    vehicle={vehicle.data.data!}
                    classes="pr-20"
                  />
                </div>
                <div className="flex flex-col">
                  <p>Parts Priority Status</p>
                  <PartsPriorityDropdown vehicle={vehicle.data.data!} classes="pr-32" />
                </div>
                <div className="flex flex-col">
                  <p>Yard Location</p>
                  <VehicleLocationDropdown vehicle={vehicle.data.data!} classes="pr-20" />
                </div>
                <div className="flex flex-col">
                  <p>Yard Status</p>
                  <YardStatusDropdown vehicle={vehicle.data.data!} classes="pr-10" />
                </div>
              </div>

              <div className="lg:grid lg:grid-cols-3 gap-4">
                <VehicleNotes vehicle={vehicle.data?.data} />
                {!lead.isLoading && lead.data?.data && <LeadNotes lead={lead.data.data!} notesProp="yardNotes" title="Yard Notes" />}
              </div>

              <PartVehicleDetails vehicle={vehicle.data?.data!} price={null} collectionQuestions />

              {/* <PartsRecall /> */}

              {lead.data?.data && <PartVehicleImages lead={lead.data.data!} />}

              <VehicleJobs vehicle={vehicle.data?.data} />

              <VehiclePartsCard vehicle={vehicle.data?.data!} />

              <CreateJobs lead={null} vehicle={vehicle.data?.data!} />
            </div>
          ),
          1: <LeadDocuments lead={lead.data?.data!} droppedFiles={undefined} setDroppedFiles={undefined} />,

        }[viewType]
      }
    </>
  );
}
